import { render, staticRenderFns } from "./OfficeRental.vue?vue&type=template&id=84274e3e&"
import script from "./OfficeRental.vue?vue&type=script&lang=js&"
export * from "./OfficeRental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports